<template>
  <transition name="fade" mode="out-in">
    <div class="main-table">
      <keep-alive :include="cachedRoutes">
        <router-view></router-view>
      </keep-alive>
      <!--<router-view v-if="!$route.meta.keepAlive"></router-view>-->
    </div>
  </transition>
</template>
<script>
  import {mapActions, mapGetters} from 'vuex'
  export default {
    name: 'AppMain',
    components: {},
    computed: {
      cachedViews () {
        return this.$store.state.tagsView.cachedViews
      },
      cachedRoutes () {
        return this.$store.state.routerIncludes.cache_includes
      }
      // key() {
      //   return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
      // }
    },
    created() {
    },
    methods: {
      ...mapGetters({
        getRouteCaches: 'routerIncludes/getRouteCaches',
      }),
    },

  }
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .main-table {
    position: relative;
    // padding: 0px;
    // margin: 0px;
  }
</style>